import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { User } from "../../_models/user";
import { Router, ActivatedRoute } from "@angular/router";
import { Globals } from "../../_models/globals";
import { AlertService } from '../../_services/alert.service';
import * as moment from 'moment';
import { ApiIntegration } from '../../_services/api.integration';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-snap-deal-create',
  templateUrl: './snap-deal-create.component.html',
  styleUrls: ['./snap-deal-create.component.scss'],
})
export class SnapDealCreateComponent implements OnInit {

  productImage: string = "/assets/images/default-product.png";
  selectedId: string;
  statusText11: string;
  statusText1: string;
  statusText2: string;
  statusText22: string;
  statusText6: string;
  apiKey: string;
  errorMessage: string;
  uploadImage: string;
  passWord: string;
  hostName: string;
  channelName: string;
  imageUrl: string;
  instructions: string = 'N';

  constructor(private alertService: AlertService, private api: ApiIntegration, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute, public g: Globals) {

    this.g.page = "Create Store Management";
    this.selectedId = this.route.snapshot.params['id']
  }

  ngOnInit() {
  }

  typeApiKey() {
    this.statusText11 = "";
    if (this.apiKey == '' || this.apiKey === null || this.apiKey === undefined || this.apiKey === 'undefined') {
      this.statusText11 = 'Please enter API key';
    }
  }

  typePassword() {
    this.statusText1 = "";
    if (this.passWord == '' || this.passWord === null || this.passWord === undefined || this.passWord === 'undefined') {
      this.statusText1 = 'Please enter Seller Auth Code';
    }
  }

  typeHostName() {
    this.statusText2 = "";
    if (this.hostName == '' || this.hostName === null || this.hostName === undefined || this.hostName === 'undefined') {
      this.statusText2 = 'Please enter AuthCode';
    }
  }

  showInstructions() {
    this.instructions = 'Y';
  }

  submit() {

    this.g.loaderDisplay = "display";

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateSnapdealStoreData', {

      "accountOwnerId": this.user.accountOwnerId,
      "authCode": this.hostName,
      "brandImageUrl": this.imageUrl,
      "clientId": this.apiKey,
      "connectionName": this.channelName,
      "organizationId": this.user.organizationId,
      "sellerAuthZCode": this.passWord

    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('SnapDeal', 'Created Successfully');
          this.router.navigate(['/admin/storeIntegrations']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  verify() {
    this.g.loaderDisplay = "display";
    this.statusText11 = "";
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText22 = '';
    if (this.channelName == '' || this.channelName === null || this.channelName === undefined || this.channelName === 'undefined') {
      this.statusText22 = 'Please enter Channel Name';
    }
    if (this.apiKey == '' || this.apiKey === null || this.apiKey === undefined || this.apiKey === 'undefined') {
      this.statusText11 = 'Please enter Api key';
    }
    if (this.passWord == '' || this.passWord === null || this.passWord === undefined || this.passWord === 'undefined') {
      this.statusText1 = 'Please enter Seller Auth Code';
    }
    if (this.hostName == '' || this.hostName === null || this.hostName === undefined || this.hostName === 'undefined') {
      this.statusText2 = 'Please enter AuthCode';
    }
    if (this.statusText22 != "" || this.statusText11 != "" || this.statusText1 != "" || this.statusText2 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/VerifySnapdealConnection', {
      "accountOwnerId": this.user.accountOwnerId,
      "authCode": this.hostName,
      "clientId": this.apiKey,
      "connectionName": this.channelName,
      "organizationId": this.user.organizationId,
      "sellerAuthZCode": this.passWord
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('SnapDeal', 'Verified Successfully');
          this.submit();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  typechannelName() {
    this.statusText22 = "";
    if (this.channelName == '' || this.channelName === null || this.channelName === undefined || this.channelName === 'undefined') {
      this.statusText22 = 'Please enter Channel Name';
    }
  }

  loadImage(event) {
    this.productImage = URL.createObjectURL(event.target.files[0]);
    this.uploadImage = event.target.files[0];
    this.errorMessage = "";
    this.submitImage();
  }

  ignoreImage() {
    this.productImage = "/assets/images/default-product.png";
    this.uploadImage = null;
    this.imageUrl = null;
    this.errorMessage = "";
  }

  submitImage() {
    this.g.loaderDisplay = "display";
    const file = this.uploadImage;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.imageUrl = data['message'];
      } else {
        this.imageUrl = "";
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.errorMessage = "Upload Image Failed Please Re-try";
      });
  }
}
